import angular from 'angular';

DashIfEmptyFilter.$inject = [];

/**
 * Placeholder for a missing grid value. Only null, undefined and '' are empty,
 * so a legitimate 0 is still displayed.
 */
export function dashIfEmpty<T>(value: T | null | undefined): T | '-' {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  return value;
}

function DashIfEmptyFilter() {
  return dashIfEmpty;
}

export const DashIfEmptyFilterModule = angular
  .module('acme.common.filter.dashIfEmpty', [])
  .filter('dashIfEmpty', DashIfEmptyFilter).name;
